export default __webpack_public_path__ + "static/media/petalwipehd_alpha-HVEC_Low.70cf0080.mov";